// extracted by mini-css-extract-plugin
export var compactFilters = "_bw-4";
export var detailImage = "_bw-1";
export var dropdownContainer = "_bw-2";
export var imageContainer = "_bw-0";
export var selectedCard = "_bw-3";